module.exports = __webpack_public_path__ + "img/done.f7f0a336.svg";